<template>
    <div id="app">
        <template v-if="$route.name == 'PageNotFound'">
            <router-view></router-view>
        </template>
        <template v-else>
            <app-header v-if="showHeader"></app-header>
            <div :class='showHeader ? "admin-page-content" : ""' id="wrapper">
                <sidebar v-if="showHeader"></sidebar>
                <router-view></router-view>
                <app-footer></app-footer>
            </div>
        </template>
    </div>
</template>

<script>
    import "@babel/polyfill";
    import Header from '@/components/partials/Header';
    import Sidebar from '@/components/partials/Sidebar';
    import Footer from "@/components/partials/Footer";
    export default {
        components: {
            'app-header':Header,
            'sidebar':Sidebar,
            'app-footer': Footer
        },
        name: 'App',
        data: () => ({
            showHeader:true,
        }),
        mounted: function() {
            var self = this;

            if(window.location.pathname == "/") {
                self.showHeader = false;
                $(".admin-page-content").css("padding-left","0");
                $(".admin-page-content").css("margin-top","0");
                $(".admin-page-content").css({"-webkit-transition":"all 0.0s ease","-moz-transition":"all 0.0s ease","-o-transition":"all 0.0s ease","transition":"all 0.0s ease"});
            } else {
                self.showHeader = true;
            }
        }
    }
</script>